// extracted by mini-css-extract-plugin
export default {"header":"Header_header__wPQ9H","item":"Header_item__yl7B2"};